import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 border-t border-white/5">
      {/* Main grid */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-3 gap-10">

        {/* Column 1: Quick Links */}
        <div>
          <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Quick Links</h3>
          <ul className="flex flex-col gap-2 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/#grades" className="hover:text-white transition-colors">Browse Grades</Link></li>
            <li><Link to="/contribute" className="hover:text-white transition-colors">Contribute a Resource</Link></li>
            <li><Link to="/about-us" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/contributors" className="hover:text-white transition-colors">Contributors</Link></li>
          </ul>
        </div>

        {/* Column 2: Resources */}
        <div>
          <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Resources</h3>
          <ul className="flex flex-col gap-2 text-sm">
            <li><Link to="/other-oers" className="hover:text-white transition-colors">Other OERs</Link></li>
            <li><Link to="/self-directed-learning" className="hover:text-white transition-colors">Self-Directed Learning</Link></li>
          </ul>
        </div>

        {/* Column 3: Disclaimer + CC */}
        <div>
          <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Disclaimer</h3>
          <p className="text-sm leading-relaxed">
            Resources on this site are primarily student-produced. We cannot guarantee accuracy,
            reliability, or completeness. Users should critically evaluate materials before use.
            Neither the founders nor North-West University assume responsibility for any errors or omissions.
          </p>
          <div className="mt-4">
            <img
              src="images/footer-cc.png"
              alt="Creative Commons License"
              className="h-8 object-contain opacity-75 hover:opacity-100 transition-opacity"
            />
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-600">
          <span>&copy; {new Date().getFullYear()} Share2Teach. All rights reserved.</span>
          <span>
            Build #{process.env.REACT_APP_BUILD_NUMBER || 'dev'} &bull;{' '}
            {process.env.REACT_APP_BUILD_DATE
              ? new Date(process.env.REACT_APP_BUILD_DATE).toLocaleDateString('en-ZA', { year: 'numeric', month: 'short', day: 'numeric' })
              : new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'short', day: 'numeric' })}
          </span>
          <span>An NWU SDL Research Unit initiative.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
